import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { EISENHOWER_META } from "../lib/eisenhower";

/**
 * Bug 19/50 · Tre card Eisenhower in Home.
 *
 * Props:
 *   - groups: {
 *       costruisci: { count: number, titles: string[] },
 *       gestisci:   { count: number, titles: string[] },
 *       risolvi:    { count: number, titles: string[] },
 *     }
 *
 * Ogni card ha CTA "Vedi tutti" che porta a /cicli filtrato per quel Eisenhower
 * (usa query string ?eisenhower=<key>; il consumo verrà fatto in una fase futura
 * — per ora si limita a navigare a /cicli lasciando il filtro come annotazione).
 */
const CARDS = [
  { key: "costruisci", subtitle: "Importante, può aspettare" },
  { key: "gestisci",   subtitle: "Importante e urgente" },
  { key: "risolvi",    subtitle: "Urgente, non importante" },
];

export default function EisenhowerCards({ groups = {} }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="home-eisenhower-cards">
      {CARDS.map(({ key, subtitle }) => {
        const meta = EISENHOWER_META[key];
        const grp = groups[key] || { count: 0, titles: [] };
        return (
          <div key={key} className="pxos-card p-5 flex flex-col" data-testid={`home-eis-card-${key}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <span className={`inline-flex text-[10px] font-semibold uppercase tracking-widest px-2 py-0.5 rounded-full ${meta.cls}`}>
                  {meta.label}
                </span>
                <div className="text-xs opacity-70 mt-1.5">{subtitle}</div>
              </div>
              <div className="text-3xl font-display font-semibold tabular-nums"
                   data-testid={`home-eis-count-${key}`}>
                {grp.count}
              </div>
            </div>
            {grp.titles.length > 0 ? (
              <ul className="mt-3 space-y-1 text-sm">
                {grp.titles.slice(0, 5).map((t, i) => (
                  <li key={i} className="truncate opacity-80" data-testid={`home-eis-title-${key}-${i}`}>
                    · {t}
                  </li>
                ))}
              </ul>
            ) : (
              <div className="mt-3 text-xs opacity-60" data-testid={`home-eis-empty-${key}`}>
                Nessun ciclo in questa categoria.
              </div>
            )}
            <div className="mt-auto pt-3">
              <Link to={`/cicli?eisenhower=${key}`}
                    className="text-xs inline-flex items-center gap-1 opacity-70 hover:opacity-100 underline"
                    data-testid={`home-eis-see-all-${key}`}>
                Vedi tutti <ArrowRight size={12}/>
              </Link>
            </div>
          </div>
        );
      })}
    </section>
  );
}
